<div class="error-message" *ngIf="errorName || errorContrasenha || showClienteError">Complete los campos obligatorios.
</div>
<div class="error-message"
    *ngIf="!errorName && !errorContrasenha && !showClienteError && (errorEmail || errorEmailNoti || errorContrasenhaMinlength || errorContrasenhaIguales)">
    Hay campos introducidos incorrectamente.</div>
<div class="ok-message fade-out"
    *ngIf="!errorName && !errorContrasenha && !errorContrasenhaMinlength && !errorEmail && !errorEmailNoti && !errorContrasenhaIguales && !showClienteError && usuarioCreado && !errorFinal">
    El usuario se ha creado correctamente.</div>
<div class="error-message fade-out" *ngIf="errorFinal">{{errorFinalMessage}}</div>

<div class="container">
    <div class="header">
        <div class="header-content">
            <span class="font20">NUEVO USUARIO DATABEER</span>
            <button mat-icon-button matTooltip="Registrar nuevo usuario" class="gurdar-btn" (click)="guardarUsuario()"
                [disabled]="waitAfterSave">
                <mat-icon>save</mat-icon>
            </button>
        </div>
        <span class="header-text font14">Formulario de alta de usuarios DataBeer</span>
    </div>
    <mat-tab-group class="custom-tab-group" color="warn" (selectedTabChange)="onTabChange($event)" *ngIf="es_estrella">
        <mat-tab label="USUARIO CORPORATIVOS MS" id="tab-userCorporativos" class="overflowAuto">
            <div class="body">
                <form [formGroup]="signin" class="width100">
                    <mat-form-field class="input-container">
                        <mat-label class="label-text">Nombre y Apellidos</mat-label>
                        <input matInput placeholder="Introduzca el nombre y apellidos del usuario"
                            formControlName="name" required>
                        <button *ngIf="nameInput?.value" matSuffix mat-icon-button aria-label="Clear"
                            (click)="clearField('name')">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-error *ngIf="errorName" class="custome">El campo Nombre no puede estar vacío</mat-error>
                </form>

                <form [formGroup]="signin" class="width100">
                    <mat-form-field class="input-container2">
                        <mat-label class="label-text">Correo electrónico</mat-label>
                        <input matInput placeholder="Ejemplo: usuarionombre@perfectnumbers.tech" formControlName="email"
                            required>
                        <button *ngIf="emailInput?.value" matSuffix mat-icon-button aria-label="Clear"
                            (click)="clearField('email')">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-error *ngIf="errorEmail" class="custome">Introducizca un email válido</mat-error>
                </form>

                <form [formGroup]="signin" class="width100">
                    <mat-form-field class="input-container2">
                        <mat-label class="label-text">Correo electrónico para notificaciones</mat-label>
                        <input matInput placeholder="Ejemplo: usuarionombre@perfectnumbers.tech"
                            formControlName="emailNoti">
                        <button *ngIf="emailNotiInput?.value" matSuffix mat-icon-button aria-label="Clear"
                            (click)="clearField('emailNoti')">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-error *ngIf="errorEmailNoti" class="custome">Introducizca un email válido</mat-error>
                </form>

                <div class="input-container2" *ngIf="clientes.length > 1">
                    <mat-label class="label-text">Cliente*</mat-label>
                    <mat-form-field class="custom2">
                        <mat-label [ngClass]="{'error-select': showClienteError}">-Elige una opción-</mat-label>
                        <mat-select [(value)]="selectedCliente" name="est" (selectionChange)="clienteSeleccionado()">
                            <mat-option *ngFor="let est of clientes" [value]="est.value">
                                {{est.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="showClienteError" class="custom3">Selecciona un cliente</mat-error>
                </div>

                <div class="input-container2 custom4">
                    <span class="label-text marginLeft1P">Perfil de acceso global</span>
                    <div class="radio-button-container">
                        <mat-radio-group aria-label="Tipo de usuario" [(ngModel)]="tipoUsuario">
                            <mat-radio-button *ngIf="userData.pro_id === 4" [value]="4">Super usuario
                                root</mat-radio-button>
                            <mat-radio-button [value]="1">Administrador</mat-radio-button>
                            <mat-radio-button [value]="2">Hostelero</mat-radio-button>
                            <mat-radio-button [value]="3">Consumidor</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <ng-container *ngIf="tipoUsuario === 2">
                    <div class="custom5">
                        <mat-icon>store</mat-icon>&nbsp;&nbsp;<span class="fontWeight500">Establecimientos *</span>
                    </div>
                    <mat-form-field class="input-container2">
                        <mat-label>-Establecimientos-</mat-label>
                        <mat-select [(ngModel)]="selectedEstablecimiento" name="modVer" multiple>
                            <mat-checkbox [(ngModel)]="selectAllEstablecimientos"
                                (change)="selectAllEstablecimientosChanged()" style="color:#FBB040 ;"
                                class="marginLeft5">
                                <span class="custom6">Seleccionar todos</span>
                            </mat-checkbox>
                            <mat-option *ngFor="let modVer of establecimientosCopia" [value]="modVer.establecimientoId">
                                {{modVer.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>

                <div class="input-container2 custom7">
                    <span class="label-text marginLeft1P">Estado</span>
                    <div class="radio-button-container">
                        <mat-radio-group aria-label="Estado del usuario" [(ngModel)]="estado">
                            <mat-radio-button [value]="1">Activado</mat-radio-button>
                            <mat-radio-button [value]="0">Desactivado</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="USUARIO RECUPERACIÓN" id="tab-userDataBeer" class="overflowAuto" *ngIf="userData.pro_id === 4">
            <div class="body">
                <form [formGroup]="signin" class="width100">
                    <mat-form-field class="input-container">
                        <mat-label class="label-text">Nombre y Apellidos</mat-label>
                        <input matInput placeholder="Introduzca el nombre y apellidos del usuario"
                            formControlName="name" required>
                        <button *ngIf="nameInput?.value" matSuffix mat-icon-button aria-label="Clear"
                            (click)="clearField('name')">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-error *ngIf="errorName" class="custome">El campo Nombre no puede estar vacío</mat-error>
                </form>

                <form [formGroup]="signin" class="width100">
                    <mat-form-field class="input-container2">
                        <mat-label class="label-text">Correo electrónico</mat-label>
                        <input matInput placeholder="Ejemplo: usuarionombre@perfectnumbers.tech" formControlName="email"
                            required>
                        <button *ngIf="emailInput?.value" matSuffix mat-icon-button aria-label="Clear"
                            (click)="clearField('email')">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-error *ngIf="errorEmail" class="custome">Introducizca un email válido</mat-error>
                </form>

                <form [formGroup]="signin" class="width100">
                    <mat-form-field class="input-container2">
                        <mat-label class="label-text">Contraseña</mat-label>
                        <input matInput placeholder="Introduzca la contraseña del usuario"
                            [type]="hide ? 'password' : 'text'" formControlName="password" required>
                        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </mat-form-field>
                    <mat-error *ngIf="errorContrasenha" class="custome">El campo contraseña no puede estar
                        vacío</mat-error>
                    <mat-error *ngIf="errorContrasenhaMinlength && !errorContrasenha" class="custome">
                        La contraseña debe tener al menos 4 caracteres
                    </mat-error>
                </form>

                <form [formGroup]="signin" class="width100">
                    <mat-form-field class="input-container2">
                        <mat-label class="label-text">Repite contraseña</mat-label>
                        <input matInput placeholder="Repita la contraseña" [type]="hideR ? 'password' : 'text'"
                            formControlName="passwordR" required>
                        <mat-icon matSuffix (click)="hideR = !hideR">{{hideR ? 'visibility_off' :
                            'visibility'}}</mat-icon>
                    </mat-form-field>
                    <mat-error *ngIf="errorContrasenhaIguales" class="custome">
                        Las contraseñas no coinciden. Asegúrate de introducir la misma contraseña</mat-error>
                    <mat-error *ngIf="passwordRInput?.hasError('minlength') && !errorContrasenha" class="custome">
                        La contraseña debe tener al menos 4 caracteres
                    </mat-error>
                </form>

                <form [formGroup]="signin" class="width100">
                    <mat-form-field class="input-container2">
                        <mat-label class="label-text">Correo electrónico para notificaciones</mat-label>
                        <input matInput placeholder="Ejemplo: usuarionombre@perfectnumbers.tech"
                            formControlName="emailNoti">
                        <button *ngIf="emailNotiInput?.value" matSuffix mat-icon-button aria-label="Clear"
                            (click)="clearField('emailNoti')">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-error *ngIf="errorEmailNoti" class="custome">Introducizca un email válido</mat-error>
                </form>

                <div class="input-container2" *ngIf="clientes.length > 1">
                    <mat-label class="label-text">Cliente*</mat-label>
                    <mat-form-field class="custom2">
                        <mat-label [ngClass]="{'error-select': showClienteError}">-Elige una opción-</mat-label>
                        <mat-select [(value)]="selectedCliente" name="est" (selectionChange)="clienteSeleccionado()">
                            <mat-option *ngFor="let est of clientes" [value]="est.value">
                                {{est.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="showClienteError" class="custom3">Selecciona un cliente</mat-error>
                </div>

                <div class="input-container2 custom4">
                    <span class="label-text marginLeft1P">Perfil de acceso global</span>
                    <div class="radio-button-container">
                        <mat-radio-group aria-label="Tipo de usuario" [(ngModel)]="tipoUsuarioRecuperacion">
                            <mat-radio-button [value]="4">Super usuario
                                root</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="input-container2 custom7">
                    <span class="label-text marginLeft1P">Estado</span>
                    <div class="radio-button-container">
                        <mat-radio-group aria-label="Estado del usuario" [(ngModel)]="estado">
                            <mat-radio-button [value]="1">Activado</mat-radio-button>
                            <mat-radio-button [value]="0">Desactivado</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    <div class="body" *ngIf="!es_estrella">
        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container">
                <mat-label class="label-text">Nombre y Apellidos</mat-label>
                <input matInput placeholder="Introduzca el nombre y apellidos del usuario" formControlName="name"
                    required>
                <button *ngIf="nameInput?.value" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearField('name')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-error *ngIf="errorName" class="custome">El campo Nombre no puede estar vacío</mat-error>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text">Correo electrónico</mat-label>
                <input matInput placeholder="Ejemplo: usuarionombre@perfectnumbers.tech" formControlName="email"
                    required>
                <button *ngIf="emailInput?.value" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearField('email')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-error *ngIf="errorEmail" class="custome">Introducizca un email válido</mat-error>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text">Contraseña</mat-label>
                <input matInput placeholder="Introduzca la contraseña del usuario" [type]="hide ? 'password' : 'text'"
                    formControlName="password" required>
                <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>
            <mat-error *ngIf="errorContrasenha" class="custome">El campo contraseña no puede estar
                vacío</mat-error>
            <mat-error *ngIf="errorContrasenhaMinlength && !errorContrasenha" class="custome">
                La contraseña debe tener al menos 4 caracteres
            </mat-error>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text">Repite contraseña</mat-label>
                <input matInput placeholder="Repita la contraseña" [type]="hideR ? 'password' : 'text'"
                    formControlName="passwordR" required>
                <mat-icon matSuffix (click)="hideR = !hideR">{{hideR ? 'visibility_off' :
                    'visibility'}}</mat-icon>
            </mat-form-field>
            <mat-error *ngIf="errorContrasenhaIguales" class="custome">
                Las contraseñas no coinciden. Asegúrate de introducir la misma contraseña</mat-error>
            <mat-error *ngIf="passwordRInput?.hasError('minlength') && !errorContrasenha" class="custome">
                La contraseña debe tener al menos 4 caracteres
            </mat-error>
        </form>

        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container2">
                <mat-label class="label-text">Correo electrónico para notificaciones</mat-label>
                <input matInput placeholder="Ejemplo: usuarionombre@perfectnumbers.tech" formControlName="emailNoti">
                <button *ngIf="emailNotiInput?.value" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearField('emailNoti')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-error *ngIf="errorEmailNoti" class="custome">Introducizca un email válido</mat-error>
        </form>

        <div class="input-container2" *ngIf="clientes.length > 1">
            <mat-label class="label-text">Cliente*</mat-label>
            <mat-form-field class="custom2">
                <mat-label [ngClass]="{'error-select': showClienteError}">-Elige una opción-</mat-label>
                <mat-select [(value)]="selectedCliente" name="est" (selectionChange)="clienteSeleccionado()">
                    <mat-option *ngFor="let est of clientes" [value]="est.value">
                        {{est.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-error *ngIf="showClienteError" class="custom3">Selecciona un cliente</mat-error>
        </div>

        <div class="input-container2 custom4">
            <span class="label-text marginLeft1P">Perfil de acceso global</span>
            <div class="radio-button-container">
                <mat-radio-group aria-label="Tipo de usuario" [(ngModel)]="tipoUsuario">
                    <mat-radio-button *ngIf="userData.pro_id === 4" [value]="4">Super usuario
                        root</mat-radio-button>
                    <mat-radio-button [value]="1">Administrador</mat-radio-button>
                    <mat-radio-button [value]="2">Hostelero</mat-radio-button>
                    <mat-radio-button [value]="3">Consumidor</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        <!--<ng-container *ngIf="tipoUsuario === 2">
            <div class="input-container2">
                <mat-label class="label-text" [ngClass]="{'error-select': showEstablecimientoError}">Establecimiento*</mat-label>
                <form style="margin-top: 10px; width: 100%;">
                    <mat-form-field class="width100">
                        <mat-label>Establecimiento</mat-label>
                        <input type="text"
                                placeholder="Elige uno"
                                aria-label="Establecimiento"
                                matInput
                                [formControl]="myControl"
                                [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected($event)">
                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <button *ngIf="myControl.value != ''" matSuffix mat-icon-button aria-label="Clear" (click)="limpiarSeleccion()">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-error *ngIf="showEstablecimientoError" class="custom3">Selecciona un establecimiento</mat-error>
                </form>
            </div>
        </ng-container>-->

        <ng-container *ngIf="tipoUsuario === 2">
            <div class="custom5">
                <mat-icon>store</mat-icon>&nbsp;&nbsp;<span class="fontWeight500">Establecimientos *</span>
            </div>
            <mat-form-field class="input-container2">
                <mat-label>-Establecimientos-</mat-label>
                <mat-select [(ngModel)]="selectedEstablecimiento" name="modVer" multiple>
                    <mat-checkbox [(ngModel)]="selectAllEstablecimientos" (change)="selectAllEstablecimientosChanged()"
                        style="color:#FBB040 ;" class="marginLeft5">
                        <span class="custom6">Seleccionar todos</span>
                    </mat-checkbox>
                    <mat-option *ngFor="let modVer of establecimientosCopia" [value]="modVer.establecimientoId">
                        {{modVer.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>

        <div class="input-container2 custom7">
            <span class="label-text marginLeft1P">Estado</span>
            <div class="radio-button-container">
                <mat-radio-group aria-label="Estado del usuario" [(ngModel)]="estado">
                    <mat-radio-button [value]="1">Activado</mat-radio-button>
                    <mat-radio-button [value]="0">Desactivado</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
    </div>
</div>
<div class="footer"></div>